import Cookies from 'js-cookie';

export function getHeaders() {
  return {
    Authorization: `Bearer ${Cookies.get('authToken')}`,
    'X-User': 'admin',
  };
}
